/* eslint-disable no-param-reassign */
import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import POSTCODE_CONSTANTS from '../constants/postcode';
import { getValue } from '../../utilities/local_storage';

class PostcodeStoreClass extends ReduceStore {
    getInitialState() {
        return {
            appliedPostcode: getValue('shippingPostcode') || '',
            nextPostcode: '',
            invalid: false,
            invalidMessage: '',
            storingInSession: false,
            postcodeExistsButNeedsToBeLoaded: false,
            postcodeSuggestion: null,
            touched: false
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.POSTCODE_ACTION) {
            switch (action.type) {
                case POSTCODE_CONSTANTS.UPDATE_POSTCODE_ACTION:
                    if (action.payload !== state.nextPostcode) {
                        state.nextPostcode = action.payload;

                        if (action.payload !== '') {
                            state.postcodeExistsButNeedsToBeLoaded = false;
                        }

                        this.__emitChange();
                    }
                    break;
                case POSTCODE_CONSTANTS.SET_POSTCODE_SUGGESTION:
                    state.postcodeSuggestion = action.payload;
                    state.invalidMessage = '';
                    state.invalid = false;
                    this.__emitChange();
                    break;

                case POSTCODE_CONSTANTS.APPLY_POSTCODE_ACTION:
                    if (action.payload !== state.appliedPostcode) {
                        state.appliedPostcode = action.payload;

                        if (action.payload !== '') {
                            state.postcodeExistsButNeedsToBeLoaded = false;
                        }

                        this.__emitChange();
                    }
                    break;

                case POSTCODE_CONSTANTS.ON_CHANGE_POSTCODE_ACTION:
                    if (action.payload !== state.appliedPostcode) {
                        state.appliedPostcode = action.payload;
                        state.touched = true;

                        if (action.payload !== '') {
                            state.postcodeExistsButNeedsToBeLoaded = false;
                        }

                        this.__emitChange();
                    }
                    break;

                case POSTCODE_CONSTANTS.POSTCODE_INVALID_ACTION:
                    if (!state.invalid) {
                        state.invalid = true;
                        state.invalidMessage = action.payload;
                        this.__emitChange();
                    }
                    break;

                case POSTCODE_CONSTANTS.POSTCODE_VALID_ACTION:
                    if (state.invalid) {
                        state.invalid = false;
                        state.invalidMessage = '';
                        this.__emitChange();
                    }
                    break;

                case POSTCODE_CONSTANTS.POSTCODE_STORE_START_ACTION:
                    if (!state.storingInSession) {
                        state.storingInSession = true;
                        this.__emitChange();
                    }
                    break;

                case POSTCODE_CONSTANTS.POSTCODE_STORE_DONE_ACTION:
                    if (state.storingInSession) {
                        state.storingInSession = false;
                        this.__emitChange();
                    }
                    break;

                case POSTCODE_CONSTANTS.POSTCODE_EXISTS_BUT_NEEDS_TO_BE_LOADED_ACTION:
                    if (!state.postcodeExistsButNeedsToBeLoaded) {
                        state.postcodeExistsButNeedsToBeLoaded = true;
                        this.__emitChange();
                    }
                    break;
                default:
                    return false;
            }
        }

        return state;
    }
}

const PostcodeStore = new PostcodeStoreClass(Dispatcher);
export default PostcodeStore;
